import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import AddTeacher from './dialogs/AddTeacherDialog';
import { setListTeacher } from './actions/teacherActions';


/**
 * Function to present the filters and search the pricing plans by the filters
 * @param {*} props
 * @returns
 */
function FilterTeacher(props) {
  const { classes } = props;
  const endpoint = 'http://127.0.0.1:8000/api';
  const [statusButtonAdd, setStatusButtonAdd] = useState(false);
  const dispatch = useDispatch();
 
  /**
  * Method to set the list pricing plans
  */
  const getAllTeachers = async() => {
    const response = await axios.get(endpoint+'/teachers');
    dispatch(setListTeacher(response.data));
    return response.data;
  };
  /**
  * Methods for the add dialog
  */
  const insertTeacher = () => {
    setStatusButtonAdd(true);
  };
  const handleCloseButtonAdd = () => {
    setStatusButtonAdd(false);
  };

  /**
   * Retrieve pricing plan list
   */
  useEffect(() => {
    getAllTeachers();  
  }, []);
  
  return (
    <div style={{textAlign:"left"}}>
          <Button  id="insertTeacher" variant="contained" style={{backgroundColor: "#ffdf40", color: "#FFFFFF"}} onClick={insertTeacher} >Ingresar Profesor</Button>
          <AddTeacher openStatus={statusButtonAdd} onClosed= {handleCloseButtonAdd}/>
          <br/>  <br/>
        </div>
  );
}

FilterTeacher.propTypes = {
  dataTeacher: PropTypes.string,
};

FilterTeacher.defaultProps = {
  dataTeacher: "true"
};

export default FilterTeacher
